import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CollateralNotes } from "@app/models/collateral-notes";
import { CollateralNotesService } from "@app/services/collateral-notes.service";

@Component({
    selector: "app-collateral-note-node",
    templateUrl: "./collateral-note-node.component.html",
    styleUrls: ["./collateral-note-node.component.css"],
    standalone: false
})
export class CollateralNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() collateralNotes: Array<CollateralNotes>;
  @Input() selectedCollateralNotes: Array<CollateralNotes>;
  @Output() onAddCollateralNote = new EventEmitter<CollateralNotes>();
  @Output() onDeleteCollateralNote = new EventEmitter<CollateralNotes>();

  constructor(private collateralNotesService: CollateralNotesService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addCollateralNote(item);
    } else {
      this.deleteCollateralNote(item);
    }
  }

  addCollateralNote(item) {
    this.onAddCollateralNote.emit(item);
  }

  deleteCollateralNote(item) {
    this.onDeleteCollateralNote.emit(item);
  }

  isSelectedCollateralNote(item: CollateralNotes): boolean {
    if (!this.selectedCollateralNotes || !item) {
      return false;
    }
    return this.selectedCollateralNotes.some((p) => p && p.id === item.id);
  }

  isIndeterminate(item: CollateralNotes): boolean {
    if (!item || !item.subCollateralNotes || item.subCollateralNotes.length === 0) {
      return false;
    }
    if (this.isSelectedCollateralNote(item)) {
      return false;
    }
    return this.hasSelectedDescendant(item);
  }

  isExpanded(item: CollateralNotes): boolean {
    if (this.isSelectedCollateralNote(item)) {
      return true;
    }
    return this.hasSelectedDescendant(item);
  }

  private hasSelectedDescendant(item: CollateralNotes): boolean {
    if (!item || !item.subCollateralNotes || item.subCollateralNotes.length === 0) {
      return false;
    }
    return item.subCollateralNotes.some(
      (child) => this.isSelectedCollateralNote(child) || this.hasSelectedDescendant(child)
    );
  }
}
